import { useSelector } from "react-redux";
const YourOrderSummary = ({item}) => {      
    let totalItem = 0;
    let CONVENIENCE_FEES = 45;
    const REQUIRE_AMOUNT = 500;
    let totalMRP = 0;
    let totalDiscount = 0;
    let productQty = 0;

    eval(`${item.order_details}`).map((elm)=>{
      totalItem+=1;
      productQty += elm.quantity;
      totalMRP += elm.product_price * elm.quantity;
      if(elm.product_offer>0){
        totalDiscount += (elm.product_price * elm.product_offer/100) * elm.quantity; 
      }     

    })    
    CONVENIENCE_FEES = (totalMRP - totalDiscount) > REQUIRE_AMOUNT ? 0 : CONVENIENCE_FEES; 

    let finalPayment = totalMRP - totalDiscount + CONVENIENCE_FEES;   
    
    return <div className="bag-summary">      
        <h5>PRICE DETAILS ( {totalItem} Items )</h5>
        <h6>Total MRP           &#x20B9;{Math.round(totalMRP)}</h6>
        <h6>Discount on MRP     &#x20B9;{Math.round(totalDiscount) }</h6>
        <h6>Convenience Fee     &#x20B9;{ CONVENIENCE_FEES}</h6>
        {/* <span style={deliveryStyle}>Delivery by {`${deliveryDateArray[0]}, ${deliveryDateArray[2]} ${deliveryDateArray[1]}`}</span><br />
        <span style={orderBeforeStyle}>if ordered before 11:59 PM</span> */}
        <hr />
        <h5>Total Amount   &#x20B9;{ Math.round(finalPayment)}</h5>
      
    </div>

}
export default YourOrderSummary;